<script lang="ts">
	import type { Device } from 'src/types/Device';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import TemplatesDeviceDrawerV2 from '../TemplatesDeviceDrawerV2.svelte';
	import { status_configurator } from 'src/helpers/device_data_helpers';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: statuses = status_configurator(status, device);
</script>

<DeviceViewStateWrapper {device}>
	<div slot="content" class="flex-full-height">
		<TemplatesDeviceDrawerV2 {device} {statuses} />
	</div>
</DeviceViewStateWrapper>
